window.navigateToPurchaseRequisition = (iframeUrl) => {
    setIFrameRoute(iframeUrl);
    openContent('container.htm');
}